"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _BookingDetailsContent = _interopRequireDefault(require("./BookingDetailsContent"));

var _AddBookingToCalendar = _interopRequireDefault(require("../AddBookingToCalendar"));

var _dateTimeFormatter = require("../../constants/propTypes/dateTimeFormatter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  bookingDetailsDateTimeBlock: {
    display: 'flex',
    flexDirection: 'column',
    padding: 'medium',
    minHeight: '100%',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'section'
  },
  bookingDetailsDateTimeContent: {
    display: 'flex',
    flexDirection: 'row'
  },
  addToCalendarWrapper: {
    display: 'flex',
    flexDirection: 'row'
  },
  iconPlaceholder: {
    width: '48px',
    marginRight: 'small',
    display: 'none',
    '@lg': {
      display: 'block'
    }
  },
  modifyBooking: {
    marginTop: 'xxsmall'
  }
};

var BookingDateTimeDetails = function BookingDateTimeDetails(_ref) {
  var booking = _ref.booking,
      dateTimeFormatter = _ref.dateTimeFormatter,
      i18n = _ref.i18n,
      domainName = _ref.domainName,
      businessName = _ref.businessName,
      onRescheduleCtaClick = _ref.onRescheduleCtaClick,
      onAddToCalendarClick = _ref.onAddToCalendarClick,
      onAddToCalendarMount = _ref.onAddToCalendarMount;
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Details = _UX2$Element.Details,
      Block = _UX2$Element.Block,
      Link = _UX2$Element.Link;
  return /*#__PURE__*/_react["default"].createElement(_BookingDetailsContent["default"], {
    icon: "okCalendar",
    title: i18n.dateAndTime,
    styles: {
      wrapper: styles.bookingDetailsDateTimeBlock,
      container: styles.bookingDetailsDateTimeContent
    },
    footer: /*#__PURE__*/_react["default"].createElement(Block, {
      style: styles.addToCalendarWrapper
    }, /*#__PURE__*/_react["default"].createElement(Block, {
      style: styles.iconPlaceholder
    }), /*#__PURE__*/_react["default"].createElement(_AddBookingToCalendar["default"], {
      businessName: businessName,
      domainName: domainName,
      label: i18n.addToCalendar,
      booking: booking,
      onAddToCalendarClick: onAddToCalendarClick,
      onAddToCalendarMount: onAddToCalendarMount,
      i18n: {
        externalCalOnlineLocation: i18n.externalCalOnlineLocation,
        nullTeleconferenceUrl: i18n.nullTeleconferenceUrl
      }
    }))
  }, /*#__PURE__*/_react["default"].createElement(Details, {
    "data-aid": _dataAids["default"].BOOKING_DATETIME
  }, dateTimeFormatter.formatDateTime(booking.start_time)), /*#__PURE__*/_react["default"].createElement(Details, null, dateTimeFormatter.getTimeZoneDisplayName()), Boolean(onRescheduleCtaClick && i18n.reschedule) && /*#__PURE__*/_react["default"].createElement(Details, {
    style: styles.modifyBooking
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    tag: "span",
    onClick: onRescheduleCtaClick,
    "data-aid": _dataAids["default"].BOOKING_DETAILS_RESCHEDULE_CTA
  }, i18n.reschedule)));
};

BookingDateTimeDetails.propTypes = {
  booking: _propTypes["default"].shape({
    start_time: _propTypes["default"].string.isRequired
  }).isRequired,
  dateTimeFormatter: _dateTimeFormatter.dateTimeFormatterPropType.isRequired,
  domainName: _propTypes["default"].string.isRequired,
  businessName: _propTypes["default"].string.isRequired,
  i18n: _propTypes["default"].shape({
    dateAndTime: _propTypes["default"].string.isRequired,
    addToCalendar: _propTypes["default"].string.isRequired,
    reschedule: _propTypes["default"].string,
    externalCalOnlineLocation: _propTypes["default"].string,
    nullTeleconferenceUrl: _propTypes["default"].string.isRequired
  }).isRequired,
  onRescheduleCtaClick: _propTypes["default"].func,
  onAddToCalendarClick: _propTypes["default"].func,
  onAddToCalendarMount: _propTypes["default"].func
};
var _default = BookingDateTimeDetails;
exports["default"] = _default;